export const VerificationStatus = {
    SUCCESS: "EMAIL_VERIFICATION_SUCCESSFUL",
    ALREADYVERIFIED: "EMAIL_ALREADY_VERIFIED",
    OTPEXPIRED: "OTP_EXPIRED",
    PENDINGSELECTDATA: "PENDING_SELECT_DATA"
}